import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Icon } from 'antd';

import Tooltip from 'shared/components/Tooltip';

import s from './TreeNode.pcss';


export default class TreeNode extends React.Component {
  static propTypes = {
    node: PropTypes.shape().isRequired,
    onClick: PropTypes.func.isRequired,
    selected: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    hasSelectedChildren: PropTypes.bool,
    childrenSelected: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
  };

  static defaultProps = {
    hasSelectedChildren: false,
    childrenSelected: false,
  };

  onMouseUp = (e) => {
    if (e.ctrKey || e.metaKey) {
      if (!this.props.disabled) {
        this.props.onSelect();
      }
    } else {
      this.props.onClick();
    }
  };

  handleSelect = () => {
    const { onSelect, disabled } = this.props;
    if (disabled) return;
    onSelect();
  };

  render() {
    const { node, selected, hasSelectedChildren, childrenSelected, disabled } = this.props;
    return (
      <div className={s.nodeContainer}>
        <div className={s.checkContainer} onClick={this.handleSelect}>
          <Checkbox
            disabled={disabled}
            indeterminate={(!selected && hasSelectedChildren) || (selected && !childrenSelected)}
            checked={selected && childrenSelected}
          />
        </div>
        <Tooltip tip={node.name} ckeckOverflow>
          <div className={s.nodeName} onMouseUp={this.onMouseUp}>
            {node.name}
          </div>
        </Tooltip>
        {node.children && node.children.length > 0 &&
          <div className={s.icon}>
            <Icon type={node.isExpanded ? 'down' : 'right'} />
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Groups/GroupPage/GrantTree/TreeNode.js